// extracted by mini-css-extract-plugin
module.exports = {"img":"user-links_img__3B6q-"};